function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { isArray as z, isDate as Nt, isObject as yt, validateValueIsFromEnum as ta } from "../util/code-utils.js";
import { logger as N, EventTypes as d } from "../../shared-lib/index.js";
import { isValidEmail as Ct, validateCustomAttributeArrayType as St, validateCustomAttributeKey as At, validateCustomProperties as rt, validateCustomString as nt, validatePropertyType as Ut, validateStandardString as ir } from "../util/validation-utils.js";
import { SET_CUSTOM_USER_ATTRIBUTE_STRING as Dt } from "../common/constants.js";
import { toValidBackendTimeString as Ft } from "../util/date-utils.js";

var User = /*#__PURE__*/function () {
  function User(t, e) {
    _classCallCheck(this, User);

    this.Cs = t, this.Fi = e, this.Cs = t, this.Fi = e;
  }

  _createClass(User, [{
    key: "getUserId",
    value: function getUserId(t) {
      var e = this.Cs.getUserId();
      if ("function" != typeof t) return e;
      N.warn("The callback for getUserId is deprecated. You can access its return value directly instead (e.g. `const id = braze.getUser().getUserId()`)"), t(e);
    }
  }, {
    key: "addAlias",
    value: function addAlias(t, e) {
      return !ir(t, "add alias", "the alias", !1) || t.length <= 0 ? (N.error("addAlias requires a non-empty alias"), !1) : !ir(e, "add alias", "the label", !1) || e.length <= 0 ? (N.error("addAlias requires a non-empty label"), !1) : this.Fi.Cn(t, e).tt;
    }
  }, {
    key: "setFirstName",
    value: function setFirstName(t) {
      return !!ir(t, "set first name", "the firstName", !0) && this.Cs.nu("first_name", t);
    }
  }, {
    key: "setLastName",
    value: function setLastName(t) {
      return !!ir(t, "set last name", "the lastName", !0) && this.Cs.nu("last_name", t);
    }
  }, {
    key: "setEmail",
    value: function setEmail(t) {
      return null === t || Ct(t) ? this.Cs.nu("email", t) : (N.error("Cannot set email address - \"".concat(t, "\" did not pass RFC-5322 validation.")), !1);
    }
  }, {
    key: "setGender",
    value: function setGender(t) {
      return "string" == typeof t && (t = t.toLowerCase()), !(null !== t && !ta(User.Genders, t, "Gender \"".concat(t, "\" is not a valid gender."), "User.Genders")) && this.Cs.nu("gender", t);
    }
  }, {
    key: "setDateOfBirth",
    value: function setDateOfBirth(t, e, r) {
      return null === t && null === e && null === r ? this.Cs.nu("dob", null) : (t = null != t ? parseInt(t.toString()) : null, e = null != e ? parseInt(e.toString()) : null, r = null != r ? parseInt(r.toString()) : null, null == t || null == e || null == r || isNaN(t) || isNaN(e) || isNaN(r) || e > 12 || e < 1 || r > 31 || r < 1 ? (N.error("Cannot set date of birth - parameters should comprise a valid date e.g. setDateOfBirth(1776, 7, 4);"), !1) : this.Cs.nu("dob", "".concat(t, "-").concat(e, "-").concat(r)));
    }
  }, {
    key: "setCountry",
    value: function setCountry(t) {
      return !!ir(t, "set country", "the country", !0) && this.Cs.nu("country", t);
    }
  }, {
    key: "setHomeCity",
    value: function setHomeCity(t) {
      return !!ir(t, "set home city", "the homeCity", !0) && this.Cs.nu("home_city", t);
    }
  }, {
    key: "setLanguage",
    value: function setLanguage(t) {
      return !!ir(t, "set language", "the language", !0) && this.Cs.nu("language", t);
    }
  }, {
    key: "setEmailNotificationSubscriptionType",
    value: function setEmailNotificationSubscriptionType(t) {
      return !!ta(User.NotificationSubscriptionTypes, t, "Email notification setting \"".concat(t, "\" is not a valid subscription type."), "User.NotificationSubscriptionTypes") && this.Cs.nu("email_subscribe", t);
    }
  }, {
    key: "setPushNotificationSubscriptionType",
    value: function setPushNotificationSubscriptionType(t) {
      return !!ta(User.NotificationSubscriptionTypes, t, "Push notification setting \"".concat(t, "\" is not a valid subscription type."), "User.NotificationSubscriptionTypes") && this.Cs.nu("push_subscribe", t);
    }
  }, {
    key: "setPhoneNumber",
    value: function setPhoneNumber(t) {
      return !!ir(t, "set phone number", "the phoneNumber", !0) && (null === t || t.match(User.Fn) ? this.Cs.nu("phone", t) : (N.error("Cannot set phone number - \"".concat(t, "\" did not pass validation.")), !1));
    }
  }, {
    key: "setLastKnownLocation",
    value: function setLastKnownLocation(t, e, r, s, n) {
      return null == t || null == e ? (N.error("Cannot set last-known location - latitude and longitude are required."), !1) : (t = parseFloat(t.toString()), e = parseFloat(e.toString()), null != r && (r = parseFloat(r.toString())), null != s && (s = parseFloat(s.toString())), null != n && (n = parseFloat(n.toString())), isNaN(t) || isNaN(e) || null != r && isNaN(r) || null != s && isNaN(s) || null != n && isNaN(n) ? (N.error("Cannot set last-known location - all supplied parameters must be numeric."), !1) : t > 90 || t < -90 || e > 180 || e < -180 ? (N.error("Cannot set last-known location - latitude and longitude are bounded by ±90 and ±180 respectively."), !1) : null != r && r < 0 || null != n && n < 0 ? (N.error("Cannot set last-known location - accuracy and altitudeAccuracy may not be negative."), !1) : this.Fi.setLastKnownLocation(this.Cs.getUserId(), t, e, s, r, n).tt);
    }
  }, {
    key: "setCustomUserAttribute",
    value: function setCustomUserAttribute(t, e, r) {
      if (!At(t)) return !1;

      var s = function s(e) {
        var _rt = rt(e, Dt, "attribute value", "set custom user attribute \"".concat(t, "\""), "custom user attribute"),
            _rt2 = _slicedToArray(_rt, 1),
            r = _rt2[0];

        return r;
      };

      if (z(e)) {
        var _St = St(t, e),
            _St2 = _slicedToArray(_St, 2),
            _r = _St2[0],
            n = _St2[1];

        if (!_r && !n && 0 !== e.length) return !1;
        if (_r || 0 === e.length) return this.Fi.Ln(d.$n, t, e).tt;

        var _iterator = _createForOfIteratorHelper(e),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _t = _step.value;
            if (!s(_t)) return !1;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else if (yt(e)) {
        if (!s(e)) return !1;
        if (r) return this.Fi.Ln(d.Bn, t, e).tt;
      } else {
        if (!(void 0 !== e && Ut(e))) return !1;
        if (Nt(e) && (e = Ft(e)), "string" == typeof e && !nt(e, "set custom user attribute \"".concat(t, "\""), "the element in the given array")) return !1;
      }

      return this.Cs.setCustomUserAttribute(t, e);
    }
  }, {
    key: "addToCustomAttributeArray",
    value: function addToCustomAttributeArray(t, e) {
      return !!nt(t, "add to custom user attribute array", "the given key") && !(null != e && !nt(e, "add to custom user attribute array", "the given value")) && this.Fi.Ln(d.On, t, e).tt;
    }
  }, {
    key: "removeFromCustomAttributeArray",
    value: function removeFromCustomAttributeArray(t, e) {
      return !!nt(t, "remove from custom user attribute array", "the given key") && !(null != e && !nt(e, "remove from custom user attribute array", "the given value")) && this.Fi.Ln(d.Gn, t, e).tt;
    }
  }, {
    key: "incrementCustomUserAttribute",
    value: function incrementCustomUserAttribute(t, e) {
      if (!nt(t, "increment custom user attribute", "the given key")) return !1;
      null == e && (e = 1);
      var r = parseInt(e.toString());
      return isNaN(r) || r !== parseFloat(e.toString()) ? (N.error("Cannot increment custom user attribute because the given incrementValue \"".concat(e, "\" is not an integer.")), !1) : this.Fi.Ln(d.Hn, t, r).tt;
    }
  }, {
    key: "setCustomLocationAttribute",
    value: function setCustomLocationAttribute(t, e, r) {
      return !!nt(t, "set custom location attribute", "the given key") && ((null !== e || null !== r) && (e = null != e ? parseFloat(e.toString()) : null, r = null != r ? parseFloat(r.toString()) : null, null == e && null != r || null != e && null == r || null != e && (isNaN(e) || e > 90 || e < -90) || null != r && (isNaN(r) || r > 180 || r < -180)) ? (N.error("Received invalid values for latitude and/or longitude. Latitude and longitude are bounded by ±90 and ±180 respectively, or must both be null for removal."), !1) : this.Fi.Kn(t, e, r).tt);
    }
  }, {
    key: "addToSubscriptionGroup",
    value: function addToSubscriptionGroup(t) {
      return !ir(t, "add user to subscription group", "subscription group ID", !1) || t.length <= 0 ? (N.error("addToSubscriptionGroup requires a non-empty subscription group ID"), !1) : this.Fi.Mn(t, User.Yn.SUBSCRIBED).tt;
    }
  }, {
    key: "removeFromSubscriptionGroup",
    value: function removeFromSubscriptionGroup(t) {
      return !ir(t, "remove user from subscription group", "subscription group ID", !1) || t.length <= 0 ? (N.error("removeFromSubscriptionGroup requires a non-empty subscription group ID"), !1) : this.Fi.Mn(t, User.Yn.UNSUBSCRIBED).tt;
    }
  }, {
    key: "setLineId",
    value: function setLineId(t) {
      return ir(t, "set LINE user ID", "the ID", !0) && 0 !== (null == t ? void 0 : t.length) ? t && t.length > User.Jn ? (N.error("Rejected LINE user ID ".concat(t, " because it is longer than ").concat(User.Jn, " characters.")), !1) : this.Cs.nu("native_line_id", t) : (N.error("setLineId requires a non-empty ID"), !1);
    }
  }, {
    key: "An",
    value: function An(t, e, r, s, n) {
      this.Cs.An(t, e, r, s, n), this.Fi.Qn();
    }
  }, {
    key: "xn",
    value: function xn(t) {
      this.Cs.xn(t);
    }
  }]);

  return User;
}();

export { User as default };
User.Genders = {
  MALE: "m",
  FEMALE: "f",
  OTHER: "o",
  UNKNOWN: "u",
  NOT_APPLICABLE: "n",
  PREFER_NOT_TO_SAY: "p"
}, User.NotificationSubscriptionTypes = {
  OPTED_IN: "opted_in",
  SUBSCRIBED: "subscribed",
  UNSUBSCRIBED: "unsubscribed"
}, User.Fn = /^[0-9 .\\(\\)\\+\\-]+$/, User.Yn = {
  SUBSCRIBED: "subscribed",
  UNSUBSCRIBED: "unsubscribed"
}, User.Xn = "user_id", User.lu = "custom", User.ur = 997, User.Jn = 33;